import { render, staticRenderFns } from "./AddSocialMediaProfileDialog.vue?vue&type=template&id=2fa8ac9e&scoped=true"
import script from "./AddSocialMediaProfileDialog.vue?vue&type=script&lang=js"
export * from "./AddSocialMediaProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./AddSocialMediaProfileDialog.vue?vue&type=style&index=0&id=2fa8ac9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa8ac9e",
  null
  
)

export default component.exports